module.exports = __webpack_public_path__ + "img/美妆-1.50658bbb.png";